// Actions
export const ONE_RECORD = 'ONE_RECORD';
export const MULTI_RECORD = 'MULTI_RECORD';

// Initial State
export const signgleRecordInitial = {
  status: true
};

// Reducer
export function singleRecord(state, action) {
  if (!state) {
    state = signgleRecordInitial;
  }
  switch (action.type) {
    case ONE_RECORD:
      return { ...state, status: false };
    case MULTI_RECORD:
      return { status: false };
    default:
      return state;
  }
}

// Action Creators
export function singleCustomer(payload) {
  return { type: ONE_RECORD, payload };
}

export function multirecord(payload) {
  return { type: MULTI_RECORD, payload };
}
